import styled from 'styled-components';

export default styled.div`
  margin: 12px 0;
  text-align: center;
`;
